<template>
  <div class="view view_Login" ref="login_view">
    <!-- Eigene, fixierte Hintergrund-Ebene (stabil, cover, mit sanftem Maus-Parallax) -->
    <div class="login-bg" ref="login_bg"></div>
    <v-container class="wrapper d-flex flex-row align-center justify-center"
      style="min-height:100vh;"
    >
      <div style="margin: auto;">
        <v-row>
          <v-col align="center">
            <v-card class="pa-8" style="max-width:400px;">
              <div ref="login_welcome" class="mb-12"></div>
              <v-alert
                v-if="passwordResetCompleted"
                type="success"
                dense
                text
                class="mb-5"
              >
                Ihr Passwort wurde geändert. Sie können sich jetzt mit dem
                neuen Passwort anmelden.
              </v-alert>
              <v-form>
                <v-text-field
                  label="Nutzername"
                  v-model="nn"
                  @keyup.enter="submit();"
                ></v-text-field>
                <v-text-field
                  type="password"
                  label="Passwort"
                  v-model="pw"
                  @keyup.enter="submit();"
                ></v-text-field>
                <v-btn
                block
                :loading="$store.state.login.loginLoading"
                @click="submit();"
                >
                  Einloggen
                </v-btn>
                <v-btn
                  v-if="passwordResetEnabled"
                  block
                  text
                  small
                  color="primary"
                  class="mt-3"
                  @click="openPasswordReset"
                >
                  Passwort vergessen?
                </v-btn>
              </v-form>
            </v-card>
          </v-col>
        </v-row>
        <v-row class="pt-4">
          <v-col style="width:800px;max-width:100vw;">
            <v-expansion-panels v-model="expansionPanel01">
              <v-expansion-panel v-for="info, key in infos" :key="key">
                <v-expansion-panel-header>
                  <b>{{ info.titel }}</b>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div v-html="info.text"></div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </div>
    </v-container>

    <v-dialog
      v-model="passwordResetDialog"
      max-width="460"
      :persistent="passwordResetLoading"
      @keydown.esc="closePasswordReset"
    >
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon dark left>
            mdi-lock-reset
          </v-icon>
          Passwort zurücksetzen
        </v-card-title>
        <v-card-text class="pt-6">
          <v-alert
            v-if="passwordResetSent"
            type="success"
            text
          >
            Falls die E-Mail-Adresse einem Konto zugeordnet ist, erhalten Sie
            eine E-Mail mit einem Link zum Zurücksetzen des Passworts.
          </v-alert>
          <template v-else>
            <p class="text-body-2">
              Geben Sie die E-Mail-Adresse an, die in Ihrem Konto hinterlegt ist.
            </p>
            <v-form
              ref="passwordResetForm"
              v-model="passwordResetFormValid"
              @submit.prevent="requestPasswordReset"
            >
              <v-text-field
                ref="passwordResetEmail"
                v-model.trim="passwordResetEmail"
                label="E-Mail-Adresse"
                type="email"
                autocomplete="email"
                prepend-icon="mdi-email-outline"
                maxlength="254"
                :disabled="passwordResetLoading"
                :rules="passwordResetEmailRules"
              ></v-text-field>
            </v-form>
            <v-alert
              v-if="passwordResetError"
              dense
              text
              type="error"
              class="mb-0"
            >
              {{ passwordResetError }}
            </v-alert>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            :disabled="passwordResetLoading"
            @click="closePasswordReset"
          >
            {{ passwordResetSent ? 'Schließen' : 'Abbrechen' }}
          </v-btn>
          <v-btn
            v-if="!passwordResetSent"
            color="primary"
            :loading="passwordResetLoading"
            :disabled="passwordResetLoading || !passwordResetFormValid"
            @click="requestPasswordReset"
          >
            Link anfordern
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import $ from 'jquery';
import applyBranding from '@/utils/branding';

export default {
  name: 'Login',
  data: () => ({
    expansionPanel01: 0,
    nn: '',
    pw: '',
    infos: [],
    passwordResetEnabled: false,
    passwordResetDialog: false,
    passwordResetEmail: '',
    passwordResetLoading: false,
    passwordResetSent: false,
    passwordResetError: '',
    passwordResetFormValid: false,
    passwordResetCompleted: false,
    // interner Zustand für den Scroll-Parallax
    parallax: {
      raf: null,
      onScroll: null,
      factor: 0.4, // wie stark der Hintergrund dem Scrollen "hinterherhängt"
      scale: 1.14, // leichtes Vergrößern -> Spielraum, damit keine Ränder frei werden
    },
  }),
  components: {
  },
  computed: {
    passwordResetEmailRules() {
      return [
        (value) => Boolean(String(value || '').trim()) || 'Bitte eine E-Mail-Adresse angeben.',
        (value) => String(value || '').length <= 254 || 'Maximal 254 Zeichen sind erlaubt.',
        (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim())
          || 'Bitte eine gültige E-Mail-Adresse angeben.',
      ];
    },
  },
  methods: {
    toDataURL(url, callback) {
      const xhr = new XMLHttpRequest();
      xhr.onload = () => {
        const reader = new FileReader();
        reader.onloadend = () => {
          callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open('GET', url);
      xhr.responseType = 'blob';
      xhr.send();
    },
    tryGetLoginscreen() {
      if (localStorage.getItem('flogin_loginscreen')) {
        // Die Reset-Freigabe ist sicherheitsrelevant und darf nie aus einem
        // moeglicherweise veralteten Offline-Cache aktiviert werden.
        this.drawLoginscreen(JSON.parse(localStorage.getItem('flogin_loginscreen')), false);
      }
      this.$store.commit('main/switchIsSaving', true);
      $.ajax({
        url: `${process.env.VUE_APP_API_HOST}/login/get.php?loginscreen`,
        type: 'post',
        data: {
        },
        success: (response) => {
          if (response.status === 'accessError') {
            this.$store.commit('login/backendErrorSession');
          } else {
            const help = JSON.parse(JSON.stringify(response.data));
            localStorage.setItem('flogin_loginscreen', JSON.stringify(help));
            this.drawLoginscreen(help, true);
          }
        },
        error: (err) => {
          console.log(err);
          // Einstellungen konnten nicht geladen werden
          this.$store.commit('main/alert', {
            typ: 'error',
            text: `Netzwerkfehler!
            Bitte die Netzwerkverbindung prüfen.`,
          }, { root: true });
          if (localStorage.getItem('flogin_loginscreen')) {
            this.drawLoginscreen(JSON.parse(localStorage.getItem('flogin_loginscreen')), false);
          }
        },
        complete: () => {
          this.$store.commit('main/switchIsSaving', false);
        },
      });
    },
    drawLoginscreen(data, allowPasswordReset = false) {
      applyBranding(data);
      this.$vuetify.theme.themes.light.primary = data.app_theme_color_primary;
      this.passwordResetEnabled = allowPasswordReset && (
        data.passwordResetEnabled === true
        || data.passwordResetEnabled === 1
        || data.passwordResetEnabled === '1'
      );
      const bg = this.$refs.login_bg;
      if (bg) {
        bg.style.backgroundColor = data.loginscreen_bg_color;
        bg.style.backgroundImage = `url('${data.loginscreen_bg_img}')`;
      }
      $(this.$refs.login_welcome).html(data.loginscreen_welcomeText);
      this.infos = [];
      const infos = Array.isArray(data.loginscreen_infos) ? data.loginscreen_infos : [];
      if (infos.length > 0) {
        infos.forEach((i) => {
          this.infos.push(i);
        });
      }
    },
    submit() {
      this.$store.dispatch('login/tryLogin', {
        session: { code: null, user: { nn: this.nn, pw: this.pw } },
        router: this.$router,
      });
    },
    openPasswordReset() {
      this.passwordResetEmail = '';
      this.passwordResetSent = false;
      this.passwordResetError = '';
      this.passwordResetDialog = true;
      this.$nextTick(() => {
        if (this.$refs.passwordResetForm) this.$refs.passwordResetForm.resetValidation();
        if (this.$refs.passwordResetEmail) this.$refs.passwordResetEmail.focus();
      });
    },
    closePasswordReset() {
      if (this.passwordResetLoading) return;
      this.passwordResetDialog = false;
      this.passwordResetEmail = '';
      this.passwordResetError = '';
      this.passwordResetSent = false;
    },
    async requestPasswordReset() {
      if (this.passwordResetLoading
        || !this.$refs.passwordResetForm
        || !this.$refs.passwordResetForm.validate()) return;

      this.passwordResetLoading = true;
      this.passwordResetError = '';
      const formData = new FormData();
      formData.append('action', 'request');
      formData.append('email', this.passwordResetEmail);
      try {
        const response = await fetch(
          `${process.env.VUE_APP_API_HOST}/login/password_reset.php`,
          {
            method: 'POST',
            body: formData,
            credentials: 'same-origin',
            referrerPolicy: 'no-referrer',
          },
        );
        let result;
        try {
          result = await response.json();
        } catch {
          throw new Error('Die Serverantwort konnte nicht verarbeitet werden.');
        }
        if (!response.ok || result.status !== 'success') {
          throw new Error(result.message || 'Die Anfrage konnte nicht verarbeitet werden.');
        }
        this.passwordResetEmail = '';
        this.passwordResetSent = true;
      } catch (error) {
        this.passwordResetError = error.message
          || 'Der Server konnte nicht erreicht werden. Bitte versuchen Sie es erneut.';
      } finally {
        this.passwordResetLoading = false;
      }
    },
    consumePasswordResetSuccess() {
      if (this.$route.query.passwordReset !== 'success') return;
      this.passwordResetCompleted = true;
      const loginRoute = this.$router.resolve({ path: '/' });
      window.history.replaceState(window.history.state, document.title, loginRoute.href);
    },
    // Scroll-Parallax: der Hintergrund bewegt sich beim Scrollen langsamer als
    // der Inhalt. background-size bleibt fest auf cover, dazu ein leichtes scale
    // als Spielraum -> stabil und unabhängig von der Content-Höhe (springt nicht
    // beim Tippen).
    initParallax() {
      const view = this.$refs.login_view;
      if (!view) return;
      const reduceMotion = window.matchMedia
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion) return;

      this.parallax.onScroll = () => {
        if (this.parallax.raf) return; // pro Frame nur einmal aktualisieren
        this.parallax.raf = window.requestAnimationFrame(() => {
          this.parallax.raf = null;
          this.updateParallax();
        });
      };
      view.addEventListener('scroll', this.parallax.onScroll, { passive: true });
      this.updateParallax();
    },
    updateParallax() {
      const bg = this.$refs.login_bg;
      const view = this.$refs.login_view;
      if (!bg || !view) return;
      const { factor, scale } = this.parallax;
      // Spielraum, den das scale nach oben/unten frei lässt (nie Ränder zeigen):
      const maxShift = ((scale - 1) / 2) * window.innerHeight;
      const shift = Math.max(-maxShift, Math.min(0, -view.scrollTop * factor));
      bg.style.transform = `translate3d(0, ${shift.toFixed(1)}px, 0) scale(${scale})`;
    },
  },
  created() {
    this.consumePasswordResetSuccess();
    this.tryGetLoginscreen();
  },
  mounted() {
    this.initParallax();
  },
  beforeDestroy() {
    if (this.parallax.onScroll && this.$refs.login_view) {
      this.$refs.login_view.removeEventListener('scroll', this.parallax.onScroll);
    }
    if (this.parallax.raf) {
      window.cancelAnimationFrame(this.parallax.raf);
    }
  },
};
</script>

<style scoped>
  .view_Login {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
  }
  /* Hintergrund-Ebene: größer als der Viewport, damit der Parallax-Versatz
     nie die Ränder freilegt. background-size bleibt fest auf cover -> stabil. */
  .view_Login .login-bg {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    /* leichtes Vergrößern -> Spielraum für den Scroll-Versatz, ohne Ränder */
    transform: scale(1.14);
    transform-origin: center center;
    will-change: transform;
    z-index: 0;
    pointer-events: none;
  }
  .view_Login .wrapper {
    position: relative;
    z-index: 1;
  }
</style>
